import styled from 'styled-components';

export default styled.div`
  background-color: ${(props) => props.theme.colors.background};
  border-radius: ${(props) => props.theme.sizes.borderRadius};
  box-shadow: 0px 1px 8px #00000033, 0px 3px 3px #0000001f,
    0px 3px 4px rgba(0, 0, 0, 0.12);
`;
